import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { CompanyFiscalType } from '../../settings/model/company-fiscal-type.enum';
import { CompanySettings } from '../../settings/model/company-settings';
import * as fromCompanySettingsStore from '../../settings/store';

export type WizardCloseReason = 'cancelled' | 'completed';

@Injectable({
  providedIn: 'root'
})
export class FdmPrecheckWizardService {
  private isOpenSubject: BehaviorSubject<boolean> = new BehaviorSubject<
    boolean
  >(false);

  private closedSubject: Subject<WizardCloseReason> = new Subject<
    WizardCloseReason
  >();

  public isOpen$: Observable<boolean> = this.isOpenSubject.asObservable();

  public get isOpen(): boolean {
    return this.isOpenSubject.value;
  }
  public closed$: Observable<
    WizardCloseReason
  > = this.closedSubject.asObservable();

  constructor(private store: Store<fromCompanySettingsStore.CompanyState>) {}

  public open(): void {
    this.isOpenSubject.next(true);
  }

  public close(reason: WizardCloseReason = 'cancelled'): void {
    this.isOpenSubject.next(false);
    this.closedSubject.next(reason);
  }

  public shouldShowUpgradeBanner(): Observable<boolean> {
    return fromCompanySettingsStore.getSettingsFromStore(this.store).pipe(
      map((companySettings: CompanySettings) => {
        return (
          companySettings.type === CompanyFiscalType.BLACKBOX &&
          !!companySettings.country &&
          companySettings.country.toLocaleLowerCase() === 'belgium'
        );
      })
    );
  }
}
